import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  path, 
  image, 
  type = "website" 
}) => {
  const siteTitle = "New Innovation";
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const siteUrl = "https://newinnovation.ge";
  const pageUrl = `${siteUrl}${path || ''}`;
  const imageUrl = image || `${siteUrl}/og-image.png`;
  const defaultDescription = "ტექნოლოგიური ბლოგი - სიახლეები ტექნოლოგიებში, პროგრამირება, ვებ-დეველოპმენტი და უფასო ხელსაწყოები დეველოპერებისთვის.";

  return (
    <Helmet>
      {/* საბაზისო მეტა-ტეგები */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <link rel="canonical" href={pageUrl} />
      
      {/* Open Graph (Facebook, LinkedIn) */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      
      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={imageUrl} />
      
      {/* Google Search Console-ის ვერიფიკაცია (ჩაანაცვლეთ თქვენი კოდით) */}
      <meta name="google-site-verification" content="YOUR_VERIFICATION_CODE" />
      
      {/* დამატებითი */}
      <meta name="robots" content="index, follow" />
      <html lang="ka" />
    </Helmet>
  );
};

export default SEO;